import { FitAssessment } from "./api";

export interface MissQuestion {
	item: string;
	category: keyof FitAssessment;
	question: string;
}

export function missQuestions(assessment: FitAssessment): MissQuestion[] {
	const questions: MissQuestion[] = [];
	(Object.keys(assessment) as (keyof FitAssessment)[]).forEach((category) => {
		assessment[category].items.forEach((item) => {
			if (item.status === "Miss" && item.necessity === "required") {
				questions.push({
					item: item.item,
					category,
					question: `Your CV doesn't show "${item.item}". Do you have it?`,
				});
			}
		});
	});
	return questions;
}

export function requiredStats(assessment: FitAssessment): { met: number; total: number } {
	const categories = [assessment.experience, assessment.skills, assessment.education, assessment.certifications];
	let total = 0;
	let met = 0;
	for (const category of categories) {
		for (const item of category.items) {
			if (item.necessity !== "required") continue;
			total += 1;
			if (item.status === "Fit") met += 1;
		}
	}
	return { met, total };
}

export function isReadyToApply(assessment: FitAssessment): boolean {
	const { met, total } = requiredStats(assessment);
	if (total === 0) return true;
	return met / total >= 0.7;
}
